var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import xs from 'xstream';
import { adapt } from '@cycle/run/lib/adapt';
function arrayEqual(requestNamespace, sourceNamespace) {
    for (var i = 0; i < sourceNamespace.length; i++) {
        if (requestNamespace[i] !== sourceNamespace[i]) {
            return false;
        }
    }
    return true;
}
export function isolateSource(httpSource, scope) {
    if (scope === null) {
        return httpSource;
    }
    return httpSource.filter(function (request) {
        return Array.isArray(request._namespace) &&
            arrayEqual(request._namespace, httpSource._namespace.concat(scope));
    }, scope);
}
export function isolateSink(request$, scope) {
    if (scope === null) {
        return request$;
    }
    return adapt(xs.fromObservable(request$).map(function (req) {
        if (typeof req === 'string') {
            return { url: req, _namespace: [scope] };
        }
        return __assign({}, req, { _namespace: [scope].concat((req._namespace || [])) });
    }));
}
//# sourceMappingURL=isolate.js.map